// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAU1Ai6XCAKe2JD-n6kE1qd1GDgh6y5V9w",
  authDomain: "xteaio.firebaseapp.com",
  projectId: "xteaio",
  storageBucket: "xteaio.firebasestorage.app",
  messagingSenderId: "603151197501",
  appId: "1:603151197501:web:b2da255eafce85fa265154",
  measurementId: "G-H1GYRMWFP7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const appleProvider = new OAuthProvider('apple.com');

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Functions and connect to emulator in development
export const functions = getFunctions(app);
if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, "localhost", 8047);
  console.log("Connected to Firebase Functions emulator on port 8047");
}